import React, { Component } from 'react';
import { connect } from 'react-redux';
import util from 'library/util';
import { createDevice, getDevice, getDeviceRoles, getDeviceWorkStations, getDeviceTypes } from 'actions/EntityActions';
import { showError, showSnackbar } from 'actions/CommonActions';
import { initializeDeviceForm, getIPAddress, updateIpAddress, formError } from 'actions/FormActions';
import LOOKUP from 'constants/lookup';
import WithRouter from 'custom/withRouter';
import { selectDeviceModel } from 'selectors/entitySelector';
import { deviceEditCrumb, deviceAddCrumb } from 'utils/breadcrumbInfo';
// Basic Components
import TextInput from 'screens/components/basic/TextInput';
import SelectInput from 'screens/components/basic/SelectInput';
import CardSimple from 'screens/components/basic/CardSimple';
import Button from 'screens/components/basic/Button';
import ToggleInput from 'screens/components/basic/ToggleInput';
import Grid from 'screens/components/basic/Grid';
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';
import DialogInputNew from 'screens/components/advanced/DialogInputNew';
import DeviceRoleSave from './DeviceRoleSave';
import DeviceWorkStationSave from './DeviceWorkStationSave';
import PageBottomWithButtons from 'screens/components/basic/PageBottomWithButtons';

class DeviceSave extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            status: null,
            roleDialog: false,
            workstationDialog: false
        };
    }

    // control if is ADD or EDIT
    componentWillMount() {
        const deviceId = this.props.params ? this.props.params.id : 0;
        //if true dispatch an action to retrive data from API and set Status to EDIT
        this.props.getDeviceRoles();
        this.props.getDeviceTypes();
        this.props.getDeviceWorkStations(this.props.branchId);

        if (deviceId) {
            this.setState({ status: "EDIT" });
            this.props.getDevice(deviceId, this.props.branchId);
        }
        //if false dispatch an action to clean the form and set default values and set Status to ADD
        else {
            this.setState({ status: "ADD" });
            this.props.init(this.props.name);
            this.updateIpAddress();
        }
    }

    // is SUCCEEDED or FAILED
    //check if the Save Success or SaveError happened
    componentWillReceiveProps(newProps) {
        if ((newProps.saveSuccess != undefined && newProps.saveSuccess !== this.props.saveSuccess)) {


            //if does changed call the respective action (SUCCESS OR FAILURE)
            if (newProps.saveSuccess)
                this.saveSuccess();
            else
                this.saveFailure();
        }
    }

    componentDidMount() {
        this.getIPAddress();
    }

    //when data is saved successfully
    saveSuccess = () => {

        this.redirectToListDevice();
        this.props.showSuccess(this.state.status === "EDIT" ? LOOKUP.device.messages.editedMessage : LOOKUP.device.messages.createdMessage);
    }

    //when data is not saved, failure
    saveFailure = () => {
        this.props.showError(LOOKUP.device.messages.saveErrorMessage);
    }

    saveDevice = () => {
        const { name, deviceModel: device } = this.props;

        const validators = [
            [name + 'DeviceType', device => (device.DeviceTypeId && device.DeviceTypeId > 0), "DeviceType"],
            [name + 'DeviceRole', device => (device.DeviceRoleId && device.DeviceRoleId > 0), "DeviceRole"],
            [name + 'DeviceWorkStation', device => (device.DeviceWorkStationId && device.DeviceWorkStationId > 0), 'DeviceWorkStation']
        ];

        if (util.validate(validators, device, this.props.formError)) {
            this.props.createDevice(device, this.props.branchId);
        }
    }

    redirectToListDevice = () => {
        this.props.navigate("/manage/device");
    }

    getIPAddress = () => {
        let findIP = new Promise(r => {
            let w = window;
            let a = new (w.RTCPeerConnection || w.mozRTCPeerConnection || w.webkitRTCPeerConnection)({
                iceServers: []
            }), b = () => { };
            a.createDataChannel("");
            a.createOffer(c => a.setLocalDescription(c, b, b), b);
            a.onicecandidate = c => {
                try {
                    if (c.candidate && c.candidate.candidate.match(/([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g)) {
                        c.candidate.candidate.match(/([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g).forEach(r);
                    }
                }
                catch (e) {
                    console.error(e);
                }
            };
        });
        findIP.then(ip => {
            this.props.getIPAddress(ip);
        }).catch(e => console.error(e));
    }

    getRoles(deviceRoles) {
        let roles = [];
        if (deviceRoles) {
            deviceRoles.map((role) => {
                roles.push({ text: role.name, value: role.id.toString() });
            });
        }
        return roles;
    }

    getWorkStations(deviceWorkStations) {
        let workStations = [];
        if (deviceWorkStations) {
            deviceWorkStations.map((workstation) => {
                workStations.push({ text: workstation.name, value: workstation.id.toString() });
            });
        }
        return workStations;
    }

    getTypes(deviceTypes) {
        let types = [];
        if (deviceTypes) {
            deviceTypes.map((type) => {
                types.push({ text: type.name, value: type.id.toString() });
            });
        }
        return types;
    }

    updateIpAddress = () => {
        this.props.updateIpAddress(this.props.ip);
    }

    openRoleDialog = () => {
        this.setState({ roleDialog: true });
    }

    closeRoleDialog = () => {
        this.setState({ roleDialog: false });
    }

    onRoleSave = () => {
        this.closeRoleDialog();
        this.props.getDeviceRoles();
    }

    openWorkStationDialog = () => {
        this.setState({ workstationDialog: true });
    }

    closeWorkStationDialog = () => {
        this.setState({ workstationDialog: false });
    }

    onWorkStationSave = () => {
        this.closeWorkStationDialog();
        this.props.getDeviceWorkStations(this.props.branchId);
    }

    render() {
        // const p = this.props;
        const { name, deviceRoles, deviceWorkStations, deviceTypes, deviceModel, ip } = this.props || {};
        const { DeviceTypeId, DeviceRoleId, DeviceWorkStationId, IPAddress, PINPadId } = deviceModel || {};

        const roles = this.getRoles(deviceRoles);
        const workstations = this.getWorkStations(deviceWorkStations);
        const types = this.getTypes(deviceTypes);
        const title = this.state.status === 'EDIT' ? "Edit Device" : "Add New Device";
        const breadCrumbPage = this.state.status === 'EDIT' ? deviceEditCrumb : deviceAddCrumb;

        const customContentStyle = {
            width: '80%'
        };

        const saveMode = (<div className="form-group pa-1">
            <div className="row">
                <div className="col-lg-12 col-xl-8 col-sm-8 pb-1">
                    <SelectInput name={`${name}DeviceType`}
                        label="Device Type"
                        floatingLabelText="Device Type"
                        hintText="Device Type"
                        options={types}
                        fullWidth
                        required />
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 pt-2 pb-1">
                    <ToggleInput className="patient_status btnToggleLabel" name={`${name}Status`} value={deviceModel.Status} label={LOOKUP.device.status.label} />
                </div>
            </div>
            <div className="row">
                <div className="col-lg-6 col-xl-6 col-sm-6 col-xs-12 pb-1">
                    <SelectInput name={`${name}DeviceRole`}
                        label="Device Role"
                        floatingLabelText="Device Role"
                        hintText="Device Role"
                        options={roles}
                        fullWidth
                        required />
                </div>
                <div className="col-lg-6 col-xl-6 col-sm-6 col-xs-12 pb-1">
                    <SelectInput name={`${name}DeviceWorkStation`}
                        label="Device WorkStation"
                        floatingLabelText="Device WorkStation"
                        hintText="Device WorkStation"
                        options={workstations}
                        fullWidth
                        required />
                </div>
            </div>
            <div className="row">
                <div className="col-lg-12">
                    <TextInput name={`${name}IPAddress`}
                        fullWidth
                        defaultValue={ip}
                        floatingLabelText={LOOKUP.device.currentipaddress.label}
                        label={LOOKUP.device.currentipaddress.label}
                        hintText={LOOKUP.device.currentipaddress.hintText}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-lg-12">
                    <TextInput name={`${name}PINPadId`}
                        fullWidth
                        floatingLabelText={LOOKUP.device.pinPadId.label}
                        label={LOOKUP.device.pinPadId.label}
                        hintText={LOOKUP.device.pinPadId.hintText}
                    />
                </div>
            </div>
        </div>);

        const editMode = (<div className="form-group pa-1">
            <div className="row">
                <div className="col-lg-8 col-xl-8 col-sm-8 pb-1">
                    <SelectInput name={`${name}DeviceType`}
                        label="Device Type"
                        defaultValue={DeviceTypeId}
                        floatingLabelText="Device Type"
                        hintText="Device Type"
                        options={types}
                        fullWidth
                        required
                    />
                </div>
                <div className="col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-3 align-items-center">
                    <ToggleInput className="patient_status btnToggleLabel" name={`${name}Status`} value={deviceModel.Status} label={LOOKUP.device.status.label} />
                </div>
            </div>
            <div className="row">
                <div className="col-lg-12 pb-1">
                    <SelectInput name={`${name}DeviceRole`}
                        label="Device Role"
                        defaultValue={DeviceRoleId}
                        floatingLabelText="Device Role"
                        hintText="Device Role"
                        options={roles}
                        required />
                </div>
            </div>
            <div className="row">
                <div className="col-lg-12 pb-1">
                    <SelectInput name={`${name}DeviceWorkStation`}
                        label="Device WorkStation"
                        defaultValue={DeviceWorkStationId}
                        floatingLabelText="Device WorkStation"
                        hintText="Device WorkStation"
                        options={workstations}
                        fullWidth
                        required />
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    <TextInput name={`${name}IPAddress`}
                        fullWidth
                        defaultValue={IPAddress}
                        floatingLabelText={LOOKUP.device.currentipaddress.label}
                        label={LOOKUP.device.currentipaddress.label}
                        hintText={LOOKUP.device.currentipaddress.hintText}
                        style={{ fontWeight: "bold", fontSize: 20 }}
                    />
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 pb-1">
                    <TextInput name={`${name}NewIPAddress`}
                        fullWidth
                        defaultValue={ip}
                        floatingLabelText={LOOKUP.device.ipaddress.label}
                        label={LOOKUP.device.ipaddress.label}
                        hintText={LOOKUP.device.ipaddress.hintText}
                        style={{ fontWeight: "bold", fontSize: 20 }}
                        disabled={true}
                    />
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 pb-1">
                    <br />
                    <Button
                        name="SaveButton"
                        className="pull-right btnNewBrandPOS"
                        label="UPDATE IP ADDRESS"
                        primary
                        onTouchTap={() => this.updateIpAddress()} />
                </div>
            </div>
            <div className="row">
                <div className="col-lg-12">
                    <TextInput name={`${name}PINPadId`}
                        fullWidth={true}
                        defaultValue={PINPadId}
                        floatingLabelText={LOOKUP.device.pinPadId.label}
                        label={LOOKUP.device.pinPadId.label}
                        hintText={LOOKUP.device.pinPadId.hintText}
                     />
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    <ToggleInput
                        className="payment_option_status btnToggleLabel"
                        name={`${name}PINPadIntegrated`}
                        label={LOOKUP.device.pinPadIntegrated.label} />
                </div> {/* .col */}
            </div>
        </div>);

        return (
            <Grid headerContent={breadCrumbPage}>
                <PageHeaderWithButton title={title}>
                    <Button
                        type="AddButton"
                        label="ADD ROLE"
                        className="bg-light-green  mr-2"
                        onTouchTap={() => this.openRoleDialog()} />

                    <Button
                        type="AddButton"
                        label="ADD WORKSTATION"
                        className="bg-light-green "
                        onTouchTap={() => this.openWorkStationDialog()} />
                </PageHeaderWithButton>
                <CardSimple className="paddingForMobileDevices">
                    {
                        (this.state.status === "ADD")
                            ? saveMode
                            : editMode
                    }
                </CardSimple>
                <PageBottomWithButtons>
                    <Button
                        id="SaveDeviceButton"
                        name="SaveButton"
                        className="pull-right btnNewBrandPOS "
                        label={LOOKUP.device.controls.saveButton}
                        primary
                        onTouchTap={() => this.saveDevice()} />
                    <Button
                        type="CancelButton"
                        name="buttonCancel"
                        className="pull-right btn-space btnCancelOperation "
                        label={LOOKUP.common.cancel.text}
                        primary={true}
                        onTouchTap={() => this.redirectToListDevice()} />
                </PageBottomWithButtons>
                <DialogInputNew
                    title="Create a Device Role"
                    handleClose={() => this.closeRoleDialog()}
                    open={this.state.roleDialog}
                    autoScrollBodyContent={false}
                    contentStyle={customContentStyle}>
                    <DeviceRoleSave
                        name={`${name} Role`} onCancel={() => this.closeRoleDialog()}
                        onSave={() => this.closeRoleDialog()}
                    />
                </DialogInputNew>
                <DialogInputNew
                    title="Create a Device workstation"
                    handleClose={() => this.closeWorkStationDialog()}
                    open={this.state.workstationDialog}
                    autoScrollBodyContent={false}
                    contentStyle={customContentStyle}>
                    <DeviceWorkStationSave
                        name={`${name} WorkStation`}
                        onCancel={() => this.closeWorkStationDialog()}
                        onSave={() => this.closeWorkStationDialog()}
                    />
                </DialogInputNew>
            </Grid>
        );
    }
}

function mapStatetoProps(state, props) {

    return {
        deviceModel: selectDeviceModel(state, props.name),
        deviceRoles: state.entity.deviceRolesList,
        deviceWorkStations: state.entity.deviceWorkStationsList,
        deviceTypes: state.entity.deviceTypesList,
        ip: state.form[props.name + "NewIPAddress"],
        saveSuccess: state.form[props.name + "SaveSuccess"],
        savedDevice: state.entity[props.name + "SavedDevice"],
        deviceKeyName: state.common.applicationSettings.deviceKeyName,
        branchId: state.common.branchId
    };
}

function mapDispatchToProps(dispatch, props) {
    return {
        init: (name) => dispatch(initializeDeviceForm(name)),
        getDeviceTypes: () => dispatch(getDeviceTypes()),
        getDeviceRoles: () => dispatch(getDeviceRoles()),
        getDeviceWorkStations: (branchId) => dispatch(getDeviceWorkStations(branchId)),
        createDevice: (device) => dispatch(createDevice(device, props.name)),
        getDevice: (deviceId, branchId) => dispatch(getDevice(deviceId, branchId, props.name)),
        getIPAddress: (ipaddress) => dispatch(getIPAddress(ipaddress, props.name)),
        updateIpAddress: (ipaddress) => dispatch(updateIpAddress(ipaddress, props.name)),
        formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error }),
        showError: (message) => dispatch(showError(message)),
        showSuccess: (message) => dispatch(showSnackbar(message))
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(WithRouter(DeviceSave));